import { useSelector } from 'store/hooks'

/**
 * Returns true when the signed-in user's organization license has the
 * `disallowUserUploads` flag set. When true, every file-upload affordance
 * (Assistant, Reference Check, and the Profile files page) is hidden.
 *
 * The flag arrives via the `/license` payload, which `check-license.js`
 * spreads into `ui.organizationLicense` — the same path `usePatentsGate`
 * uses for `grantedScopes`. Anonymous and non-license users are unaffected
 * (the field resolves to `undefined` → not disallowed).
 */
export default function useUploadsDisallowed() {
  const organizationLicense = useSelector(({ ui }) => ui.organizationLicense)
  return organizationLicense?.disallowUserUploads === true
}
